import { TagData } from '@/types/tags'

const TAGS_API_URL = '/api/tags'

/**
 * 获取所有tags数据
 */
export async function getTags(): Promise<TagData> {
  try {
    const response = await fetch(TAGS_API_URL)
    if (!response.ok) {
      throw new Error('Failed to fetch tags')
    }
    return await response.json()
  } catch (error) {
    console.error('Error fetching tags:', error)
    // 返回空的默认数据
    return {
      mixPairTags: {},
      allTags: []
    }
  }
}

/**
 * 为mixpair添加tag
 */
export async function addTag(mixPairIndex: number, tag: string): Promise<TagData> {
  try {
    const response = await fetch(`${TAGS_API_URL}/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ mixPairIndex, tag }),
    })
    
    if (!response.ok) {
      throw new Error('Failed to add tag')
    }
    
    return await response.json()
  } catch (error) {
    console.error('Error adding tag:', error)
    throw error
  }
}

/**
 * 从mixpair删除tag
 */
export async function removeTag(mixPairIndex: number, tag: string): Promise<TagData> {
  try {
    const response = await fetch(`${TAGS_API_URL}/remove`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ mixPairIndex, tag }),
    })
    
    if (!response.ok) {
      throw new Error('Failed to remove tag')
    }
    
    return await response.json()
  } catch (error) {
    console.error('Error removing tag:', error)
    throw error
  }
}

